module.exports = __webpack_public_path__ + "img/Logo_CCQC.ff91f1d9.png";